export const P_SINGLE = 'P_SINGLE'
export const SET_SINGLE_PACKAGE_CRITERIA = "SET_SINGLE_PACKAGE_CRITERIA";
export const SET_DD_VALUES = "SET_DD_VALUES";